import { render } from "./TextManager.vue?vue&type=template&id=6fd41d9f&scoped=true"
import script from "./TextManager.vue?vue&type=script&lang=js"
export * from "./TextManager.vue?vue&type=script&lang=js"

import "./TextManager.vue?vue&type=style&index=0&id=6fd41d9f&scoped=true&lang=css"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd41d9f"]])

export default __exports__